import { createStore, applyMiddleware, Action, Dispatch } from 'redux';
import { composeWithDevTools } from '@redux-devtools/extension';
import { persistStore, persistReducer } from 'redux-persist';
import { requestStatusMiddleware } from 'RequestStatusModule/middleware';
import storage from 'redux-persist/lib/storage';
import { thunk, ThunkAction, ThunkDispatch } from 'redux-thunk';
import type { UnknownAction } from '@reduxjs/toolkit';

import rootReducer from '../reducers';

const composeEnhancers = composeWithDevTools({});

const persistConfig = {
  key: 'root',
  storage: storage,
  // Persist theme to preserve light/dark mode across refreshes
  whitelist: ['authReducer', 'profileReducer', 'themeReducer'],
};

const persistRootReducer = persistReducer(persistConfig, rootReducer);

const middlewares = [thunk, requestStatusMiddleware];

const store = createStore(persistRootReducer, composeEnhancers(applyMiddleware(...middlewares)));
const persistor = persistStore(store);

// Type definitions for Redux
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, undefined, Action>;

// Legacy type for backward compatibility
export type AppDispatchType = AppDispatch;

export { store, persistor };
